import React from 'react';
import Link from 'next/link';
import Icon from '@/app/components/Icon';
import { useSelector } from 'react-redux';
import TextSmall from '../../Typography/TextSmall';
import { socialLinksData } from '../footerMenuList';

function FooterCorporateAddress() {
  const { usernames } = useSelector((state) => state.chatLink);

  return (
    <div className="min-w-[385px] max-w-[20.26%] space-y-[12px]">
      <Icon type="singer" />
      <TextSmall className="text-white text-sm lg:text-sm font-medium">
        <span className="block font-bold">Corporate Address</span>
        Singer Bangladesh Limited <br />
        Gulshan Center Point, House # 23-26 (21st Floor), <br />
        Road # 90-91, Gulshan-2, Dhaka, Bangladesh 1212
      </TextSmall>

      <TextSmall
        text="Connect with Us"
        className="text-white text-sm lg:text-sm font-semibold"
      />

      <div className="flex items-center gap-[14px]">
        {socialLinksData?.map((item) => (
          <Link
            prefetch={false}
            aria-label="Go to social link"
            key={item?.id}
            href={
              item.id === 'whatsapp'
                ? `${item?.href}${usernames.whatsapp}`
                : item?.href
            }
            target={item?.target}
          >
            <Icon type={item?.iconType} />
          </Link>
        ))}
      </div>
    </div>
  );
}

export default FooterCorporateAddress;
